import { get, patch, post } from '../https'
import { BASE_URL } from '../endpoints'
import { SchoolDetails } from '../../utils/types'

export const getSchool = (): Promise<unknown> => {
  return get(`${BASE_URL}/school`)
}

export const updateSchool = (data: SchoolDetails): Promise<unknown> => {
  return patch(`${BASE_URL}/school`, data, null)
}

export const getAllUsers = (): Promise<unknown> => {
  return get(`${BASE_URL}/users`)
}

export const getUsers = (
  page: number,
  sortBy: string,
  sortOrderValue: string
): Promise<unknown> => {
  console.log(page)
  return get(`${BASE_URL}/users?sortBy=${sortBy}&sortOrder=${sortOrderValue}`)
}

export const verifyUser = (
  uId: string,
  verificationStatus: string,
  isEmailSend: boolean
): Promise<unknown> => {
  const data = {
    verificationStatus: verificationStatus,
    sendInvitationEmail:isEmailSend
  }
  return post(`${BASE_URL}/users/${uId}/verification`, data, null)
}
